import curatedCollectionCover from '../images/curated-collection.jpg';
import buildCover from '../images/build.jpg';
import projectPortfolioCover from '../images/project-portfolio.jpg';
import commercialEditCover from '../images/commercial-edit.jpg';
import curatedCollectionCoverSm from '../images/curated-collection-448.jpg';
import buildCoverSm from '../images/build-448.jpg';
import projectPortfolioCoverSm from '../images/project-portfolio-448.jpg';
import commercialEditCoverSm from '../images/commercial-edit-448.jpg';

/**
 * The cover the design draws for each publication, keyed by newsletter series.
 *
 * The chooser used to show the latest issue's own cover, which is market-scoped
 * and changes fortnightly. These are the frame's covers instead: the series are
 * the same in every market, so one set serves NZ, AU and US, and the artwork
 * stops moving under the design.
 *
 * Cropped to the frame's 94:130 box from the top, which is where the masthead
 * and headline sit — the covers are authored much taller than the box, and the
 * part below the strapline is not what the box is composed around.
 *
 * Keyed on the series rather than the HubSpot ID, which differs per environment,
 * or the title, which is editable copy. A series with no entry here keeps the
 * latest issue's cover, so enabling a fifth publication in the CMS still shows
 * something.
 */
export const PublicationCovers: Record<string, string> = {
    'Curated Collection': curatedCollectionCover,
    Build: buildCover,
    'The Project Portfolio': projectPortfolioCover,
    'Commercial Edit': commercialEditCover,
};

/**
 * The same covers at 448px wide.
 *
 * These are bundled assets, so the CDN's image loader cannot resize them and
 * one file would otherwise serve every screen. The box is 434px on the desktop
 * frame and about 203px on a phone, so the 892px art is right for a retina
 * desktop and two to four times more than a phone can use — 556KB of covers
 * where 158KB would do, on a row that draws on phones.
 */
export const PublicationCoversSmall: Record<string, string> = {
    'Curated Collection': curatedCollectionCoverSm,
    Build: buildCoverSm,
    'The Project Portfolio': projectPortfolioCoverSm,
    'Commercial Edit': commercialEditCoverSm,
};

/** The design's cover box — width, and the ratio its height follows. */
export const PUBLICATION_COVER_ASPECT = 'aspect-[94/130]';

/**
 * What the box measures, so the browser can pick between the two exports.
 * 14rem on a phone and the design's 434 above md.
 */
export const PUBLICATION_COVER_SIZES = '(min-width: 768px) 434px, 14rem';
